var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-6 col-6 px-4"},[_c('h5',{staticClass:"pb-3 text-capitalize fu-deal__column-title"},[_vm._v("Deal activity")]),_c('lead-board-deal-activity-todo-list'),_c('lead-board-deal-activity-comments')],1)}
var staticRenderFns = []

export { render, staticRenderFns }